import request from '../config/axios-config'

// 获取学校评论配置项
export function commentConfig(id){
  return request({
    url: `/api/blade-food/scoreindex/ignore/getList?tenantId=${id}`,
    method: 'get'
  })
}
// 发布评论
export function publish(data){
  return request({
    url: '/api/blade-food/recipecomment/ignore/save',
    method: 'post',
    data
  })
}